module.exports = __webpack_public_path__ + "media/directory/x_icon-ad3046cd.svg";